module.exports = __webpack_public_path__ + "static/img/icon-02.13a8e2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-02.jpg
// module id = cMby
// module chunks = 1